class ImageWithTextVideoModal {
  constructor() {
    this.init();
  }

  init() {
    // Find all play button triggers
    const playButtons = document.querySelectorAll("[data-video-modal-trigger]");

    playButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const modalId = button.getAttribute("data-video-modal-trigger");
        this.openModal(modalId);
      });
    });

    // Find all close buttons and overlays
    const closeButtons = document.querySelectorAll("[data-video-modal-close]");

    closeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const modalId = button.getAttribute("data-video-modal-close");
        this.closeModal(modalId);
      });
    });

    // Close modal on Escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        const openModal = document.querySelector(
          ".image-with-text__video-modal:not([hidden])"
        );
        if (openModal) {
          this.closeModal(openModal.id);
        }
      }
    });
  }

  openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    // Get video container
    const videoContainer = modal.querySelector(
      ".image-with-text__video-modal-content"
    );
    const videoPlayer = modal.querySelector("video");
    const iframe = modal.querySelector("iframe");

    // Try to enter fullscreen first
    const enterFullscreen = () => {
      const element = videoContainer || modal;

      if (element.requestFullscreen) {
        return element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        return element.webkitRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        return element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        return element.msRequestFullscreen();
      }
      return Promise.reject(new Error("Fullscreen not supported"));
    };

    // Remove hidden attribute but keep modal visually hidden initially
    modal.removeAttribute("hidden");
    modal.style.display = "none";

    // Prevent body scroll
    document.body.style.overflow = "hidden";

    // Handle iframe - restore src if it was removed
    if (iframe) {
      const backupSrc = iframe.getAttribute("data-src-backup");
      if (backupSrc && !iframe.src) {
        iframe.src = backupSrc;
      } else if (!iframe.src) {
        const originalSrc = iframe.getAttribute("data-original-src");
        if (originalSrc) {
          iframe.src = originalSrc;
        }
      }
    }

    // Try to enter fullscreen
    enterFullscreen()
      .then(() => {
        // Fullscreen successful - show video container
        modal.style.display = "flex";

        // Hide overlay and close button in fullscreen
        const overlay = modal.querySelector(
          ".image-with-text__video-modal-overlay"
        );
        const closeButton = modal.querySelector(
          ".image-with-text__video-modal-close"
        );
        if (overlay) overlay.style.display = "none";
        if (closeButton) closeButton.style.display = "none";

        // Play video if it's a video element
        if (videoPlayer) {
          videoPlayer.play().catch((err) => {
            console.warn("Video autoplay failed:", err);
          });
        }

        // Listen for fullscreen exit
        const handleFullscreenChange = () => {
          const isFullscreen =
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement;

          if (!isFullscreen) {
            // Exited fullscreen - show modal normally with overlay and close button
            modal.style.display = "flex";
            if (overlay) overlay.style.display = "block";
            if (closeButton) closeButton.style.display = "block";

            // Focus on close button for accessibility
            if (closeButton) {
              setTimeout(() => {
                closeButton.focus();
              }, 100);
            }

            // Remove this listener
            document.removeEventListener(
              "fullscreenchange",
              handleFullscreenChange
            );
            document.removeEventListener(
              "webkitfullscreenchange",
              handleFullscreenChange
            );
            document.removeEventListener(
              "mozfullscreenchange",
              handleFullscreenChange
            );
            document.removeEventListener(
              "MSFullscreenChange",
              handleFullscreenChange
            );
          }
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener(
          "webkitfullscreenchange",
          handleFullscreenChange
        );
        document.addEventListener(
          "mozfullscreenchange",
          handleFullscreenChange
        );
        document.addEventListener("MSFullscreenChange", handleFullscreenChange);
      })
      .catch(() => {
        // Fullscreen failed or not supported - show modal normally
        modal.style.display = "flex";

        // Focus on close button for accessibility
        const closeButton = modal.querySelector(
          ".image-with-text__video-modal-close"
        );
        if (closeButton) {
          setTimeout(() => {
            closeButton.focus();
          }, 100);
        }

        // Play video if it's a video element
        if (videoPlayer) {
          videoPlayer.play().catch((err) => {
            console.warn("Video autoplay failed:", err);
          });
        }
      });
  }

  closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    // Exit fullscreen if currently in fullscreen
    const isFullscreen =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    if (isFullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }

    // Pause video if it's a video element
    const videoPlayer = modal.querySelector("video");
    if (videoPlayer) {
      videoPlayer.pause();
      videoPlayer.currentTime = 0;
    }

    // For iframes (YouTube/Vimeo), stop playback by removing src
    const iframe = modal.querySelector("iframe");
    if (iframe) {
      // Store original src before removing (if not already stored)
      if (!iframe.getAttribute("data-original-src")) {
        iframe.setAttribute("data-original-src", iframe.src);
      }
      // Store current src as backup
      iframe.setAttribute("data-src-backup", iframe.src);
      // Remove src to stop playback
      iframe.src = "";
    }

    // Restore overlay and close button display
    const overlay = modal.querySelector(
      ".image-with-text__video-modal-overlay"
    );
    const closeButton = modal.querySelector(
      ".image-with-text__video-modal-close"
    );
    if (overlay) overlay.style.display = "";
    if (closeButton) closeButton.style.display = "";

    // Hide modal
    modal.setAttribute("hidden", "");
    modal.style.display = "";

    // Restore body scroll
    document.body.style.overflow = "";
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new ImageWithTextVideoModal();
  });
} else {
  new ImageWithTextVideoModal();
}
